import React from 'react';
import { FormikProps } from 'formik';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AppFormSelectWrapper from '../../../components/designe/app-form-select-wrapper';

interface IExerciseLoadFormulasFilterProps {
  formik: FormikProps<any>;
  filterActiveOptions: Array<{ id: string | boolean; name: string }>;
}

export function ExerciseLoadFormulasFilter(
  props: IExerciseLoadFormulasFilterProps,
) {
  const { formik, filterActiveOptions } = props;
  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid item sm={4}>
        <AppFormSelectWrapper
          label={t('common.active')}
          name="active"
          options={filterActiveOptions}
          disableClear={false}
          formik={formik}
        />
      </Grid>
    </Grid>
  );
}
